import React from "react";

// i18n
import { useTranslation } from "react-i18next";

// Components
import PageIcon from "../../components/Svgs/PageIcon";
import Typography from "../../components/Typography";

// Styles
import styles from "./style.module.scss";

const DraggingOverlay: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <PageIcon />

      <Typography variant="p" className={styles.title}>
        {t("generate.snapshot.dragging_overlay.drop_anything")}
      </Typography>

      <Typography variant="p" className={styles.description}>
        {t("generate.snapshot.dragging_overlay.drop_anything_description")}
      </Typography>
    </div>
  )
}

export default DraggingOverlay;
